import { platformDir } from "../utils/brand";

// Endpoint por plataforma. Se puede sobreescribir en RUNTIME desde build/env.js
// (window.__MXD_ENV__.API_BASE) sin recompilar. Si en env.js se cambia PLATFORM,
// el endpoint sigue a la plataforma elegida automáticamente.
const ENDPOINTS: Record<string, string> = {
  maxdream: "https://maxdream.com.ar/mxd/ws/v1/",
  laketravel: "https://maxdream.com.ar/ltc/ws/v1/",
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const runtimeEnv = ((window as any).__MXD_ENV__ || {}) as {
  API_BASE?: string;
  BANNER_VERSION?: string;
};
const API_BASE =
  runtimeEnv.API_BASE || ENDPOINTS[platformDir] || ENDPOINTS.maxdream;

// Versión del banner para cache-busting (ver public/env.js). Editable en runtime.
const BANNER_VERSION = runtimeEnv.BANNER_VERSION || "1";

const config = {
  ROUTES_API: [API_BASE],
  SESION_TIME: 1800000,
  BANNER_VERSION,
};

export default config;
